/* import __COLOCATED_TEMPLATE__ from './carousel-block-styles.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();